<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      right
      :timeout="2500"
      :color="snackbar_color"
      top
      >{{ snackbar_text }}</v-snackbar
    >

    <v-layout column class="mt-4 ml-4">
      <header-elements
        icon="mdi-information-variant"
        @showUpload="showUpload = !showUpload"
        title="Information Carriers"
      ></header-elements>
      <elements-table v-if="this.information_carriers"
        :items="ics"
        :showUpload="showUpload"
        @showUpload="showUpload = !showUpload"
        title="Information Carrier"
      ></elements-table>

      <!-- <div class="mt-4 mb-3">
          <v-flex style="background-color:#e2e2e2;" class="px-3 py-2 elevation-1 xs12">
            <h3 class="subtitle xs12 flex">Information Carriers</h3>
            </v-flex>
        </div>       -->
      <!-- <v-flex xs12 sm12 md12 v-if="information_carriers && information_carriers.length>0">
          <v-list class="xs12">
            <v-list-tile v-for="f in information_carriers" :key="f.id">
              <v-list-tile-title>
                <b>{{f.title}}</b>
              </v-list-tile-title>
              <v-list-tile-title>Brand: {{f.brand}}</v-list-tile-title>
              <v-list-tile-title>Type: {{f.type}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_information_carrier" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_information_carrier" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
        </v-flex> -->

      <!-- <v-flex class="mt-0 mb-0 xs12" v-show="!showUpload">
            <v-btn icon @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn>
            Add new Information Carriers
      </v-flex> -->

      <v-flex v-if="showUpload">
        <v-container grid-list-xs fluid class="elevation-2">
          <v-layout row wrap>
            <h4 class="headline xs12">Add new Information Carrier</h4>
            <v-spacer></v-spacer>
            <span class="pt-0 mt-0 mb-0 xs12 right" v-show="showUpload">
              <v-btn class="pt-0 mt-0 mb-3" icon @click="showUpload = !showUpload"
                ><v-icon>close</v-icon></v-btn
              >
              <!-- Cancel -->
            </span>

            <v-flex class="xs12">
              <v-text-field
                v-model="information_carrier.title"
                label="Title"
              ></v-text-field>
            </v-flex>

            <v-flex class="xs12 md6">
              <v-text-field
                v-model="information_carrier.brand"
                label="Brand"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 md6">
              <v-text-field
                v-model="information_carrier.type_and_model"
                label="Type and Model"
              ></v-text-field>
            </v-flex>

            <v-flex class="xs12">
              <h3 class="subheadline xs12">
                Type of Information Carrier | Specifications | Technology
              </h3>
            </v-flex>

            <v-flex class="xs12 my-0 mt-3 pb-0 mb-0">
              <!-- <v-radio-group row v-model="information_carrier.optical_film" label="Optical Film"> -->
              <v-select
                label=""
                v-model="information_carrier.ic_type"
                :items="[
                  'optical_films',
                  'optical_discs',
                  'mechanical',
                  'magnetic',
                  'electronical',
                  'unknown',
                  'other'
                ]"
                class="ml-1"
              ></v-select>
              <!-- </v-radio-group> -->
            </v-flex>

            <v-flex
              v-if="information_carrier.ic_type == 'optical_films'"
              class="xs12 my-0 py-02 mx-5"
            >
              <!-- <v-radio-group row v-model="information_carrier.optical_film" label="Optical Film"> -->
              <v-select
                label="Optical Film"
                :items="constants.OPTICAL_FILMS"
                v-model="information_carrier.optical_films"
                item-value="id"
                item-text="name"
                class="ml-3"
              ></v-select>
              <!-- </v-radio-group> -->
            </v-flex>
            <v-flex v-if="type == 'optical_discs'" xs122 mx-5>
              <v-radio-group row v-model="information_carrier.optical_disc">
                <v-radio
                  v-for="vs in constants.OPTICAL_DISCS"
                  :key="vs.id"
                  :value="vs.id"
                  :label="vs.name"
                  class="ml-3"
                  color="black"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="type == 'mechanical'" xs122 mx-5>
              <v-radio-group row v-model="information_carrier.mechanical">
                <v-radio
                  v-for="vs in constants.MECHANICAL"
                  :key="vs.id"
                  :value="vs.id"
                  :label="vs.name"
                  color="black"
                  class="ml-3"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="type == 'magnetic'" xs122 mx-5>
              <v-radio-group row v-model="information_carrier.magnetic">
                <v-radio
                  v-for="vs in constants.MAGNETIC"
                  :key="vs.id"
                  :value="vs.id"
                  :label="vs.name"
                  color="black"
                  class="ml-3"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="type == 'electronical'" xs12 mx-5>
              <!-- <label class="subheadline">Electronical</label> -->
              <v-radio-group row v-model="information_carrier.electronical">
                <v-radio
                  v-for="vs in constants.ELECTRONICAL"
                  :key="vs.id"
                  :value="vs.id"
                  :label="vs.name"
                  color="black"
                  class="ml-3"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="type == 'unknown'" class="xs12 mx-5">
              <v-text-field
                v-model="information_carrier.unknown"
                label="Unknown"
              ></v-text-field>
            </v-flex>
            <v-flex v-if="type == 'other'" class="xs12 mx-5">
              <v-text-field
                v-model="information_carrier.other"
                label="Other"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
                <!-- row -->
              <v-radio-group class="ml-2"
                v-model="information_carrier.material"
                label="Material | Carrier Base"
              >
                <v-radio
                  v-for="vs in constants.MATERIALS"
                  :key="vs.id"
                  :value="vs.id"
                  :label="vs.name"
                  color="black"
                  class="ml-5 pl-2"
                ></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex class="xs12">
              <v-textarea
                rows="1"
                auto-grow
                v-model="information_carrier.specifications"
                label="Specifications"
              ></v-textarea>
            </v-flex>
            <v-flex class="xs12 md6 pr-3">
              <v-text-field
                v-model="information_carrier.length"
                label="Length"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 md6">
              <v-text-field
                v-model="information_carrier.number_of_parts"
                label="Number of Parts"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12">
              <v-text-field
                v-model="information_carrier.associated_devices"
                label="Associated Devices"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12">
              <v-btn @click="add" dark class="right">save</v-btn>
              <v-btn @click="showUpload = !showUpload" class="right">cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
import axios from "axios"; 
const show_field = field => {
  if (field.condition && information_carrier) {
    var theInstructions = field.condition;
    var F = theInstructions => {};
    return F();
  } else {
    return true;
  }
};
// import EditField from "./EditField";
import HeaderElements from "./HeaderElements";
import ElementsTable from "./ElementsTable";
export default {
  props: ["artwork"],
  data() {
    return {
      snackbar_color: "black",
      snackbar_text: "",
      snackbar: false,
      information_carriers: Object.assign({},this.artwork.artwork_elements),
      // information_carriers: [],
      type: "",
      information_carrier: {},
      //   title: "",
      //   optical_film: "",
      //   optical_disc: "",
      //   mechanical: "",
      //   magnetic: "",
      //   electronical: "",
      //   unknown: "",
      //   other: "",
      //   material: "",
      //   brand: "",
      //   type: "",
      //   specifications: "",
      //   length: "",
      //   number_of_parts: "",
      //   associated_devices: "",
      //   audio_signal: "",
      //   video_signal: "",
      //   generation: "",
      //   status: "",
      //   production_date: "",
      //   installation_specs: "",
      //   shell: "",
      //   modifications: "",
      //   specs_on_installation: "",
      //   attached_documents: "",
      //   associated_peripherals: "",
      //   content: "",
      //   behaviour: "",
      //   appearance: "",
      //   context: "",
      //   concept: "",
      //   structure: "",
      //   input_output: "",
      //   filesize: "",
      //   associated_devices: "",
      //   other_associated_devices: "",
      //   associated_information_carriers: "",
      //   creation_date: "",
      //   notes: ""
      // },
      showUpload: false,
      show: false
    };
  },
  // created() { 
  //   console.log('created'); 
  //   console.log(this.artwork);
  // },
  // updated() { console.log('updated'); 
  //   console.log(this.artwork);
  // },
  beforeUpdate() { 
    // console.log('beforeUpdate'); 
    // console.log(this.artwork);
    this.information_carriers = this.artwork.artwork_elements;

  },
  // mounted() {
  //   // this.getElements()
  //   // console.log("this.artwork.artwork_elements");
  //   console.log('mounted');
  //   console.log(this.artwork);
  //   // this.information_carriers = this.artwork.artwork_elements;
  //   //.filter((ic) => ic.category == 'information_carrier');
  //   // this.journals_store = this.$store.state.journals.filter(
  //   //   j => j.journaled_id == this.artwork.id
  //   // );
  // },
  methods: {
    // getElements() {
    //   setTimeout(() => {
    // this.information_carriers = this.artwork.information_carriers.filter((ic) => ic.category == 'information_carrier');

    //   let url = `${this.$globals.apiserver}/artwork_elements/index_artwork/${this.artwork.id}.json`;
    //   axios
    //     .get(url)
    //     .then(response => {
    //       this.information_carriers = response.data
    //       this.progress = false;
    //     })
    //     .catch(error => {
    //       // console.log(error)
    //     });
    //   }, 1000);
    // },
    // set_input(f) {
    //   information_carrier[f] = f;
    // },
    // download() {},
    add() {
      this.information_carrier.artwork_id = this.artwork.id;
      this.information_carrier.category = "information_carrier";
      let url = `${this.$globals.apiserver}/artwork_elements.json`;
      axios
        .post(url, { artwork_element: this.information_carrier })
        .then(response => {
          // console.log(response.data);
          // this.artwork = response.data;
          // this.$store.dispatch("addArtwork", response.data);
          this.snackbar_color = "green";
          this.snackbar_text = "Information Carrier saved.";
          // this.$store.dispatch("loadUsers");
          this.snackbar = true;
          this.information_carriers.push(response.data);
          this.showUpload = !this.showUpload;
          // if (a == 1) {
          // console.log(this.artwork);
          // this.$router.push({
          //   path: `/artworks/edit/${this.artwork.id}`,
          //   params: { artwork: this.artwork }
          // });
          // }
          // this.$store.dispatch('addArtwork',response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
        })
        .catch(error => {
          this.snackbar_color = "red";
          this.snackbar_text = "Error occured while saving Information Carrier.";
          // this.$store.dispatch("loadUsers");
          this.snackbar = true;
          // console.log(error);
          // console.log(response.data);
        });
      // }
    },
    delete_information_carrier() {}
    // done_information_carrier() {},
    // show_field_c(field) {
    //   // console.log(this.information_carrier)
    //   return show_field(field, this.information_carrier);
    // }
  },
  computed: {
    ics() {
      // console.log("ics");
      // console.log(this.artwork);
      // console.log(this.artwork.artwork_elements);
      this.information_carriers = this.artwork.artwork_elements;
      // console.log(this.information_carriers);
      // if(this.information_carriers && this.information_carriers.length > 0) {
      return this.information_carriers;
      //.filter((ic) => ic.category == 'information_carrier');
      // } else {
      //   return []
      // }
    }
  },
  components: {
    // "edit-field-p": EditField,
    HeaderElements,
    ElementsTable
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/artworks/InformationCarrier.vue